import basicApi from '@/api/basic'
import { getAllUncheckCount } from '@/api/app'

export default {
  getAllUncheckCount ({ dispatch }) {
    return getAllUncheckCount()
      .then(res => {
        return dispatch('updateCount', res)
      })
  },
  getAllLocations ({ commit }, payload) {
    const query = { version: 2, returnType: 1, ...payload }

    return basicApi.getAllLocation(query)
      .then(({ locations = [] }) => {
        commit('LOCATIONS_SET', locations)
      })
  },
  updateCount ({ commit }, payload) {
    commit('UPDATE_COUNT', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js